import React from "react";
import { AppointmentPhase } from "../../../components";
import { newLineToBr } from "../../../utilities";
import FileList from "./filelist";
import Travellers from "./travellers";
import { PhosphorPencilButton } from "components/Atoms/PhosphorIconButton";

interface Props {
  flight: server.dto.Flight
  onFlightEditClicked: (flight: server.dto.Flight) => void
  onFilesAddClick: () => void
}

export default class GeneralFlightDetail extends React.Component<Props> {
  public render(): JSX.Element {
    const { flight } = this.props;

    return <div className="content-section">
      <table className="s1_table">
        <tbody>
          <tr>
            <td>{RESX.Status.resxStatus}</td>
            <td className="s1_cell_bigpadding flex">
              <div className="grow1">
                <AppointmentPhase value={flight.phase} displayLabel />
              </div>
              {this.props.flight.permissions.canModify && <PhosphorPencilButton
                layout="in-square"
                onClick={() => this.props.onFlightEditClicked(this.props.flight)}
              />}
            </td>
          </tr>

          {flight.artist && <tr>
            <td>{RESX.Flight.Travellers}</td>
            <td className="s1_cell_bigpadding">
              <Travellers travellers={flight.travellers} />
              <div className="s1_gray">{flight.artist.name}</div>
            </td>
          </tr>}

          {(flight.bookingCode || null) && <tr>
            <td>{RESX.Flight.BookingCode}</td>
            <td className="s1_cell_bigpadding">{flight.bookingCode}</td>
          </tr>}

          {(flight.travelAgency || null) && <tr>
            <td>{RESX.Flight.TravelAgency}</td>
            <td className="s1_cell_bigpadding">{flight.travelAgency}</td>
          </tr>}

          {(flight.notes || null) && <tr>
            <td>{RESX.Note.Notes}</td>
            <td className="s1_cell_bigpadding">{newLineToBr(flight.notes)}</td>
          </tr>}

          <tr>
            <td>{RESX.File.Files}</td>
            <td className="s1_cell_bigpadding">
              <FileList
                files={flight.files}
                onAddFilesClick={this.props.onFilesAddClick}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>;
  }
}
